/**
 * My Measurements State Types
 *
 * Type definitions for the MyMeasurements state slice.
 * Database-backed state with real-time Firestore sync and local caching,
 * filtered by the user's studentIds array. State (including cache) is fully
 * reset whenever studentIds changes.
 */

import type { Observation } from 'src/app/domain/observations/types/observations.types';

/** Signal state model for the MyObservationsState slice. */
export interface MyMeasurementsStateModel {
  // === Data ===
  data: Observation[];

  // === Status Flags ===
  initialized: boolean;
  loading: boolean;
  error: string | null;

  // === Metadata ===
  lastUpdated: number | null;
  lastSync: number | null;
  hydratedFromCache: boolean;

  // === Context ===
  activeTeamId: string | null;
  studentIds: string[];
}

/** Configuration required to initialize MyObservationsState for a practitioner's caseload. */
export interface MyObservationsInitConfig {
  activeTeamId: string;
  studentIds: string[];
  enableRealtimeUpdates?: boolean;
  /** Additional teams to load measurements from and merge into this state (no realtime listener). */
  additionalTeamContexts?: Array<{ teamId: string; studentIds: string[] }>;
}

export const MY_OBSERVATIONS_DEFAULTS: MyMeasurementsStateModel = {
  data: [],
  initialized: false,
  loading: false,
  error: null,
  lastUpdated: null,
  lastSync: null,
  hydratedFromCache: false,
  activeTeamId: null,
  studentIds: [],
};
